import { render, staticRenderFns } from "./DefaultResultCard.vue?vue&type=template&id=2d543034&"
import script from "./DefaultResultCard.vue?vue&type=script&lang=ts&"
export * from "./DefaultResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports